export default {"src":"https://images-cdn-staging.curipod.com/d-85f467eb/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};